"use client";

import styles from "./main-cta-btn.module.css";
import React, {AnchorHTMLAttributes, ButtonHTMLAttributes, ReactNode} from "react";
import {cn} from "@/lib/utils";

const BASE_CLASSES =
    "text-[12px] p-[12px] leading-none rounded-[8px] font-semibold cursor-pointer";
// The site's CTA: gold texture under a hairline.
const TEXTURED = "border border-stroke-gold text-noble-black-900";
// The bonus centre's button (Figma "09 · Bonuses": cards, ladder banner, promo
// dialog): plain gold, no texture and no border; switched off, it is the
// card's inset block.
const PLAIN = "bg-bonus-gold text-[#17191C] transition-colors hover:bg-[#F3CE83] disabled:cursor-not-allowed disabled:bg-bonus-inset disabled:text-bonus-text-muted";

// Renders a `<button>` by default; pass `href` to render a styled `<a>` instead
// (used for progressive-enhancement CTAs that must work before hydration).
type MainCtaBtnProps =
    | ({children: ReactNode; disabled?: boolean; plain?: boolean; href?: undefined} & ButtonHTMLAttributes<HTMLButtonElement>)
    | ({children: ReactNode; plain?: boolean; href: string} & AnchorHTMLAttributes<HTMLAnchorElement>);

export const MainCtaBtn = (props: MainCtaBtnProps) => {
    if (props.href !== undefined) {
        const {children, className, plain, ...rest} = props;
        return (
            <a className={cn(BASE_CLASSES, 'flex items-center justify-center', plain ? PLAIN : [TEXTURED, styles.Button], className)} {...rest}>
                {children}
            </a>
        );
    }

    const {children, disabled, className, plain, ...rest} = props;
    return (
        <button
            className={cn(
                BASE_CLASSES,
                plain ? PLAIN : [TEXTURED, styles.Button, {[styles.ButtonDisabled]: disabled}],
                className,
            )}
            disabled={disabled}
            {...rest}
        >
            {children}
        </button>
    );
};
